export const navConfig = {
  'super-admin': {
    label: 'Super Admin',
    nav: [
      { id: 'dash', label: 'Dashboard', icon: 'LayoutDashboard', path: '/admin/dashboard' },
      { id: 'leads', label: 'Leads', icon: 'Users', path: '/admin/leads' },
      { id: 'employees', label: 'Employees', icon: 'UserGroup', path: '/admin/employees' },
      { id: 'sources', label: 'Lead Setting', icon: 'PlusCircle', path: '/admin/lead-sources' },
      { id: 'reports', label: 'Reports', icon: 'BarChart3', path: '/admin/reports' },
      { id: 'notif', label: 'Notifications', icon: 'Bell', path: '/admin/notifications' },
      { id: 'whatsapp', label: 'WhatsApp API', icon: 'MessageSquare', path: '/admin/whatsapp' },
      { id: 'wa-web', label: 'WA Web', icon: 'Smartphone', path: '/admin/wa-web' },
      { id: 'lead-scraper', label: 'Lead Scraper', icon: 'MapPin', path: '/admin/lead-scraper' },
      { id: 'upgrade', label: 'Upgrade Plan', icon: 'Zap', path: '/admin/pricing' },
      { id: 'automation', label: 'Automation', icon: 'Bot', path: '/automation' },
      { id: 'media-library', label: 'Media Library', icon: 'FolderOpen', path: '/media-library' },
      { id: 'email-inbox', label: 'Email Inbox', icon: 'MailIcon', path: '/email-inbox' },
    ]
  },
  'manager': {
    label: 'Manager',
    nav: [
      { id: 'dash', label: 'Dashboard', icon: 'LayoutDashboard', path: '/manager/dashboard' },
      { id: 'leads', label: 'Leads', icon: 'Users', path: '/manager/leads' },
      { id: 'team', label: 'My Team', icon: 'UserGroup', path: '/manager/team' },
      { id: 'sources', label: 'Lead Setting', icon: 'PlusCircle', path: '/admin/lead-sources' },
      { id: 'reports', label: 'Reports', icon: 'BarChart3', path: '/manager/reports' },
      { id: 'notif', label: 'Notifications', icon: 'Bell', path: '/manager/notifications' },
      { id: 'whatsapp', label: 'WhatsApp API', icon: 'MessageSquare', path: '/manager/whatsapp' },
      { id: 'wa-web', label: 'WA Web', icon: 'Smartphone', path: '/manager/wa-web' },
      { id: 'lead-scraper', label: 'Lead Scraper', icon: 'MapPin', path: '/manager/lead-scraper' },
      { id: 'automation', label: 'Automation', icon: 'Bot', path: '/automation' },
      { id: 'media-library', label: 'Media Library', icon: 'FolderOpen', path: '/media-library' },
      { id: 'email-inbox', label: 'Email Inbox', icon: 'MailIcon', path: '/email-inbox' },
    ]
  },
  'executive': {
    label: 'Executive',
    nav: [
      { id: 'dash', label: 'Dashboard', icon: 'LayoutDashboard', path: '/executive/dashboard' },
      { id: 'leads', label: 'My Leads', icon: 'Users', path: '/executive/leads' },
      { id: 'reports', label: 'Reports', icon: 'BarChart3', path: '/executive/reports' },
      { id: 'notif', label: 'Notifications', icon: 'Bell', path: '/executive/notifications' },
      { id: 'whatsapp', label: 'WhatsApp API', icon: 'MessageSquare', path: '/executive/whatsapp' },
      { id: 'wa-web', label: 'WA Web', icon: 'Smartphone', path: '/executive/wa-web' },
      { id: 'automation', label: 'Automation', icon: 'Bot', path: '/automation' },
      { id: 'media-library', label: 'Media Library', icon: 'FolderOpen', path: '/media-library' },
      { id: 'email-inbox', label: 'Email Inbox', icon: 'MailIcon', path: '/email-inbox' },
    ]
  },
  'telecaller': {
    label: 'Telecaller',
    nav: [
      { id: 'dash', label: 'Dashboard', icon: 'LayoutDashboard', path: '/telecaller/dashboard' },
      { id: 'leads', label: 'Calling List', icon: 'Users', path: '/telecaller/leads' },
      { id: 'reports', label: 'Reports', icon: 'BarChart3', path: '/telecaller/reports' },
      { id: 'notif', label: 'Notifications', icon: 'Bell', path: '/telecaller/notifications' },
      { id: 'whatsapp', label: 'WhatsApp API', icon: 'MessageSquare', path: '/telecaller/whatsapp' },
      { id: 'wa-web', label: 'WA Web', icon: 'Smartphone', path: '/telecaller/wa-web' },
      { id: 'automation', label: 'Automation', icon: 'Bot', path: '/automation' },
      { id: 'media-library', label: 'Media Library', icon: 'FolderOpen', path: '/media-library' },
      { id: 'email-inbox', label: 'Email Inbox', icon: 'MailIcon', path: '/email-inbox' },
    ]
  },
  'site-visit-agent': {
    label: 'Site Visit Agent',
    nav: [
      { id: 'dash', label: 'Dashboard', icon: 'LayoutDashboard', path: '/site-visit/dashboard' },
      { id: 'leads', label: 'Assigned Visits', icon: 'Users', path: '/site-visit/leads' },
      { id: 'reports', label: 'Reports', icon: 'BarChart3', path: '/site-visit/reports' },
      { id: 'notif', label: 'Notifications', icon: 'Bell', path: '/site-visit/notifications' },
      { id: 'automation', label: 'Automation', icon: 'Bot', path: '/automation' },
    ]
  }
};
